import React from 'react';

class SegmentShape extends React.Component{
  render(){
    return(
      <div>
        <p>Segmentation of shapes feature coming soon!</p>
      </div>
    );
  }
};

export { SegmentShape };


// WEBPACK FOOTER //
// ./src/components/SegmentShapeOptions.js